/** Normalize user/symbol input to base asset (e.g. `BTC-USDT-SWAP` → `BTC`). */
export function normalizeSymbolInput(value: string): string {
  const upper = value.trim().toUpperCase();
  if (!upper) return '';
  return upper
    .replace(/-USDT-SWAP$/, '')
    .replace(/-USDT$/, '')
    .replace(/_USDT$/, '')
    .replace(/USDT$/, '');
}

/** Auto-generate both exchange inst ids from a base symbol. */
export function generateExchangeInstIds(
  exchange1: string,
  exchange2: string,
  symbol: string,
): { instId1: string; instId2: string } {
  const base = normalizeSymbolInput(symbol);
  return {
    instId1: symbolToExchangeInstId(exchange1, base),
    instId2: symbolToExchangeInstId(exchange2, base),
  };
}

/** Map exchange + base symbol to native perpetual `inst_id` used by APIs / trading-engine. */
export function symbolToExchangeInstId(exchange: string, symbol: string): string {
  const base = normalizeSymbolInput(symbol);
  const normalizedExchange = exchange.trim().toLowerCase();
  if (!base) return '';
  if (normalizedExchange === 'okx') return `${base}-USDT-SWAP`;
  if (['binance', 'bitget', 'bybit'].includes(normalizedExchange)) return `${base}USDT`;
  if (normalizedExchange === 'hyperliquid') return base;
  if (normalizedExchange === 'gateio') return `${base}_USDT`;
  return base;
}
